// extracted by mini-css-extract-plugin
export default {"container":"list-card_container__SImKK","content":"list-card_content__hjUrX"};